<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M7.4 10.4h12.7q.6 0 1 .5.6.5.5 1.1t-.4 1.1q-.5.5-1.1.5H7.4l5.2 5.2q.5.5.5 1.1t-.5 1.1-1.1.5-1.1-.5l-8-7.9-.4-1a2 2 0 0 1 .5-1.2l7.9-8q.5-.4 1-.4.8 0 1.2.5.5.5.5 1.1t-.5 1.1z"
    />
  </svg>
</template>
